module.exports = __webpack_public_path__ + "img/ybkLogo.7afb01f5.jpg";